import React from 'react';

const LineArrow = () => (
  <svg width="26" height="15" viewBox="0 0 26 15" fill="blue" xmlns="http://www.w3.org/2000/svg">
    <path d="M18.5945 0.823223L18.4177 0.646443L18.2409 0.823228L17.1719 1.89231L16.9951 2.06909L17.1719 2.24586L21.5023 6.57632H1H0.75V6.82632V8.33825V8.58825H1H21.5023L17.1719 12.9187L16.9951 13.0954L17.1719 13.2722L18.2409 14.3413L18.4177 14.5181L18.5945 14.3413L25.1768 7.75901L25.3536 7.58223L25.1768 7.40545L18.5945 0.823223Z" fill="currentColor" stroke="transparent" strokeWidth="0.5"/>
  </svg>
);

export default LineArrow;
